import React, { useRef } from 'react';
import {
	useState,
	axios,
	API_URL,
	formConfig,
	toast,
	Loader,
	useNavigate,
	useLocation,
	config,
	// InputField,
} from '../../../Data/Imports';
import ProductFields from './ProductFields';

const AddProductForm = () => {
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	// Reference for the file inoput field
	const thumbnailRef = useRef(null);
	const imagesRef = useRef(null);

	const editMode = location?.state?.mode === 'edit';
	const editData = location?.state?.productData;

	const intialData = {
		ProductName: '',
		CategoryId: '',
		CategoryIdName: '',
		SubCategoryId: '',
		SubCategoryIdName: '',
		StyleCodeId: '',
		StyleCodeIdName: '',
		BrandId: '',
		BrandIdName: '',
		SizeId: '',
		SizeIdName: '',
		ColorId: '',
		ColorIdName: '',
		ParentImagePath: '',
		StockQty: 1,
		MRP: '',
		DiscountPrice: '',
		NetPrice: '',
		Description: '',
		MetaData: '',
		ImageFile: null,
	};

	const [productData, setProductData] = useState(editMode ? editData : intialData);

	const [productImages, setProductImages] = useState([]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const requiredPairs = [
			{ id: 'CategoryId', name: 'CategoryIdName', label: 'Category' },
			{ id: 'SubCategoryId', name: 'SubCategoryIdName', label: 'SubCategory' },
			{ id: 'StyleCodeId', name: 'StyleCodeIdName', label: 'Style Code' },
			{ id: 'BrandId', name: 'BrandIdName', label: 'Brand' },
			{ id: 'SizeId', name: 'SizeIdName', label: 'Size' },
			{ id: 'ColorId', name: 'ColorIdName', label: 'Color' },
		];

		// Check if any name field is filled but ID is missing
		const missingIds = requiredPairs
			.filter(({ id, name }) => productData[name]?.trim() && !productData[id])
			.map(({ label }) => label);

		if (missingIds.length > 0) {
			toast.error(`Please select a valid ${missingIds.join(', ')}`);
			setLoading(false);
			return;
		}

		const searchMeta = {
			ProductName: productData.ProductName,
			Category: productData.CategoryIdName,
			SubCategory: productData.SubCategoryIdName,
			StyleCode: productData.StyleCodeIdName,
			Brand: productData.BrandIdName,
			Size: productData.SizeIdName,
			Color: productData.ColorIdName,
			Description: productData.Description,
			MRP: productData.MRP,
			DiscountPrice: productData.DiscountPrice,
			NetPrice: productData.NetPrice,
		};

		productData.MetaData = JSON.stringify(searchMeta);

		const formDataToSend = new FormData();
		Object.keys(productData).forEach((key) => {
			formDataToSend.append(key, productData[key]);
		});

		try {
			const response = await axios.post(
				`${API_URL}/stock/post/add-stock`,
				formDataToSend,
				formConfig
			);

			toast.success(response?.data?.message);
			if (response?.data?.ProductId) {
				await addProductImages(response?.data?.ProductId);
			}
			handleReset();
		} catch (error) {
			toast.error(error?.response?.data?.message);
		} finally {
			setLoading(false);
		}
	};

	const addProductImages = async (ProductId) => {
		try {
			setLoading(true);
			const formData = new FormData();
			productImages.forEach((img) => formData.append('ImageFile', img.ImageFile));
			formData.append('ProductId', ProductId);

			const response = await axios.post(`${API_URL}/stock/post/add-stock-images`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			});

			toast.success(response?.data?.message);
		} catch (error) {
			toast.error(error?.response?.data?.message);
		}
	};

	const handleReset = () => {
		if (editMode) {
			navigate('/product-list');
		} else {
			setProductData(intialData);
			setProductImages([]);
			if (thumbnailRef.current) thumbnailRef.current.value = '';
			if (imagesRef.current) imagesRef.current.value = '';
		}
	};

	const handleUpdateProduct = async (e) => {
		e.preventDefault();

		const requiredPairs = [
			{ id: 'CategoryId', name: 'CategoryIdName', label: 'Category' },
			{ id: 'SubCategoryId', name: 'SubCategoryIdName', label: 'SubCategory' },
			{ id: 'StyleCodeId', name: 'StyleCodeIdName', label: 'Style Code' },
			{ id: 'BrandId', name: 'BrandIdName', label: 'Brand' },
			{ id: 'SizeId', name: 'SizeIdName', label: 'Size' },
			{ id: 'ColorId', name: 'ColorIdName', label: 'Color' },
		];

		// Check if any name field is filled but ID is missing
		const missingIds = requiredPairs
			.filter(({ id, name }) => productData[name]?.trim() && !productData[id])
			.map(({ label }) => label);

		if (missingIds.length > 0) {
			toast.error(`Please select a valid ${missingIds.join(', ')}`);
			setLoading(false);
			return;
		}

		const searchMeta = {
			ProductName: productData.ProductName,
			Category: productData.CategoryIdName,
			SubCategory: productData.SubCategoryIdName,
			StyleCode: productData.StyleCodeIdName,
			Brand: productData.BrandIdName,
			Size: productData.SizeIdName,
			Color: productData.ColorIdName,
			Description: productData.Description,
			MRP: productData.MRP,
			DiscountPrice: productData.DiscountPrice,
			NetPrice: productData.NetPrice,
		};

		productData.MetaData = JSON.stringify(searchMeta);

		const updateProductData = {
			ProductId: productData.Id,
			ProductName: productData.ProductName,
			CategoryId: productData.CategoryId,
			SubCategoryId: productData.SubCategoryId,
			StyleCodeId: productData.StyleCodeId,
			BrandId: productData.BrandId,
			SizeId: productData.SizeId,
			ColorId: productData.ColorId,
			Description: productData.Description,
			MRP: productData.MRP,
			DiscountPrice: productData.DiscountPrice,
			NetPrice: productData.NetPrice,
			StockQty: productData.StockQty,
			MetaData: productData.MetaData,
		};

		setLoading(true);
		try {
			const response = await axios.post(
				`${API_URL}/stock/update/update-stock`,
				updateProductData,
				config
			);

			toast.success(response?.data?.message);
			handleReset();
		} catch (error) {
			toast.error(error?.response?.data?.message || 'Something Went Wrong');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className=' w-full p-6 shadow-lg rounded-lg '>
			{loading && (
				<div className='fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50'>
					<Loader />
				</div>
			)}
			<div>
				<h2 className='text-2xl font-bold mb-5 text-center'>
					{editMode ? 'Edit Product' : 'Add New Product'}
				</h2>

				{/* Form */}

				<form onSubmit={editMode ? handleUpdateProduct : handleSubmit}>
					<ProductFields
						productData={productData}
						setProductData={setProductData}
						thumbnailRef={thumbnailRef}
						imagesRef={imagesRef}
						productImages={productImages}
						setProductImages={setProductImages}
						editMode={editMode}
					/>
					{!editMode === 'edit' && productData?.ParentImagePath && (
						<div className=' flex gap-5'>
							<img
								src={productData?.ParentImagePath}
								alt='Preview'
								className='w-32 h-32 object-contain mt-2'
							/>
							{productImages?.map((img, index) => (
								<div key={index} className=' flex'>
									<img
										src={img.ImagePath}
										alt='Preview'
										className='w-32 h-32 object-contain mt-2'
									/>
								</div>
							))}
						</div>
					)}

					<div className='w-full flex justify-end gap-10 my-5 col-span-3'>
						<button type='submit' className='globalButton p-2 rounded cursor-pointer'>
							Submit
						</button>
						<button
							onClick={handleReset}
							type='button'
							className='bg-gray-500 text-white p-2 rounded cursor-pointer'>
							Cancel
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default AddProductForm;
